<template>
  <router-view></router-view>
  <notifications />
  <LoaderBar :loading="loading" />

</template>

<script lang="ts" setup>
import LoaderBar from "@/components/LoaderBar.vue";
import { Notifications } from '@/components/base/notifications';
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useQueryHistory } from "@/composables/use-query-history";
const { addQuery } = useQueryHistory();
const route = useRoute();
const router = useRouter();
const loading = ref<boolean>(false);
let loadingStartTime = 0;  // Track when loading starts

// Watch for route changes and update the document title
watch(
  () => route.meta?.title,
  () => {
    document.title = (route.meta?.title as string) || 'Admin';
  },
  { immediate: true }
);
watch(
  () => route.query,
  (newQuery: any) => {
    // Add a copy of the query object to the Map
    if (Object.keys(newQuery).length !== 0) {
      addQuery(route.path, { ...newQuery });
    }
  },
  { deep: true } // Deep watch to detect nested changes
);
// Use navigation guards to toggle loading state during route changes
router.beforeEach((to, from, next) => {
  const sameRouteName: boolean = (to.name === from.name);
  if (loading.value) return;
  if (!sameRouteName) {
    loading.value = true;
    loadingStartTime = Date.now();
  }
  next();
});

const minLoadingTime = 300; // Minimum time in ms for the loader to be visible
router.afterEach(() => {
  const elapsedTime = Date.now() - loadingStartTime;

  // If less than 500ms has passed, delay the removal of the loader
  if (elapsedTime < minLoadingTime) {
    setTimeout(() => {
      loading.value = false;
    }, minLoadingTime - elapsedTime);
  } else {
    loading.value = false;
  }
});
</script>
